import { render, staticRenderFns } from "./cards-list.vue?vue&type=template&id=5c205d6d&"
import script from "./cards-list.vue?vue&type=script&lang=js&"
export * from "./cards-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports